<tam-dialog [opened]="dialogOpened" [dialogWidth]="800" class="container">
    <ng-template #title>
        <span class="dialog-title">{{dialogTitle}}</span>
        <smart-icon class="dark dialog-close" name="close" (click)="cancelClick()">
        </smart-icon>
    </ng-template>
    <ng-template #body>
        <div class="dialog-body" loading-spin [isLoading]="loading" [loadingSize]="'big'">
            <div class="tab" *ngIf="!loading">
                <tabs [options]="tabsOptions" [underlineStyle]="true"></tabs>
            </div>
            <div class="content" *ngIf="!loading">
                <div *ngIf="tabActive===0" class="basic-div">
                    <form [formGroup]="contentForm">
                        <div class="tam-form-field" [ngClass]="{'has-error': name.invalid}">
                            <div class="tam-form-label">
                                <span>Name&nbsp;<span class="required-field">*</span></span>
                            </div>
                            <input type="text" class="tam-textbox" formControlName="name">
                            <div class="tam-form-help" *ngIf="name.invalid && name.errors['required']">
                                {{'general.required_error_message' | stringLiterals}}
                            </div>
                            <div class="tam-form-help" *ngIf="name.invalid && name.errors['maxlength']">
                                {{'dashboard.dashboard_name_exceed_maximum' | stringLiterals: '128'}}
                            </div>
                            <div class="tam-form-help" *ngIf="name.invalid && name.errors['duplicated']">
                                {{'general.name_already_exist' | stringLiterals}}
                            </div>
                            <div class="tam-form-help" *ngIf="name.invalid && name.errors['specialCharacter']">
                                Special character ' or / is not allowed.
                            </div>
                        </div>
                        <div class="tam-form-field" [ngClass]="{'has-error': description.invalid}">
                            <div class="tam-form-label">
                                <span>Description</span>
                            </div>
                            <textarea class="tam-textbox textarea" formControlName="description"></textarea>
                            <div class="tam-form-help" *ngIf="description.invalid && description.errors['maxlength']">
                                Dashboard description exceeds the maximum of 256 characters allowed.
                            </div>
                        </div>
                    </form>
                    <div class="tam-form-field">
                        <tam-focus-setting [config]="focusSettingConfig"></tam-focus-setting>
                    </div>
                    <div class="tam-form-help" *ngIf="errorMsg">
                        {{errorMsg}}
                    </div>
                </div>
                <div *ngIf="tabActive===1" class="access-div">
                    <span>Public</span>
                    <kendo-switch onLabel="Yes" offLabel="No" [(ngModel)]="defaultConfig.isPublic"></kendo-switch>
                    <div class="list-box" [hidden]="defaultConfig.isPublic">
                        <tam-dual-list #dualList [config]="dualListConfig" [itemRender]="accessListItem">
                            <ng-template #accessListItem let-item>
                                <div class="access-item">
                                    <span
                                        [style.font-weight]="item.data.type === 'team' ? 'bold' : 'normal'">{{item.data.name}}</span>
                                </div>
                            </ng-template>
                        </tam-dual-list>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template #footer>
        <button class="footer-button footer-research-button" tam-button [tamType]="'tertiary'" [tamSize]="'normal'"
            (click)="cancelClick()">Cancel</button>
        <button class="footer-button footer-research-button" tam-button [tamType]="'primary'" [tamSize]="'normal'"
            (click)="onSave()" [tamLoading]="isSaving" [disabled]="isSaving">Save</button>
    </ng-template>
</tam-dialog>
